import { HeadLine } from '../../layouts/headers/HeadLine';
import CSS from 'csstype';
import './Style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { NoAuthAlertComponent } from '../../components/card/NoAuthAlertComponent';
import { useSelector } from 'react-redux';
import { ExperienceOrderCard } from './ExperienceOrderCard';

export const ExperienceDetailPage2 = () => {

    const user = useSelector((store: any) => (store.auth));

    const checkIcon = <FontAwesomeIcon icon={faCheck} color='#67BAAF' />;
    const bgimage: CSS.Properties = { background: "url('/assets/img/experiencias_bg3.png') no-repeat center center / cover" };
    const [scrollpos, setScrollpos] = useState(316);

    const handleScroll = (e) => {

        if (e.target.scrollTop > 0) {
            setScrollpos(137);
        } else {
            setScrollpos(316);
        }

    }

    return <>

        <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
            <HeadLine title='Experiencias Románticas' backurl='../' />
        </div>

        <div className="w-full relative content-hi-sm">
            <div className="flex justify-center items-center" style={msgWarnStyle}>
                <span>El cobro del servicio se realizará a tu tarjeta de crédito registrada</span>
            </div>
            <div className="bg_room_page flex justify-center items-center bg_page_top" style={bgimage}>
                {/* <img src="/assets/img/icons/experiencias-icon.svg" alt="Icono room" /> */}
            </div>
        </div>

        <div className="absolute z-1 w-full border shadow detail-experience-container pb-4 bg_page_top"
            onScroll={handleScroll} style={{ height: `calc(100% - ${scrollpos}px)` }}>

            {
                !user &&
                (<div className="mt-4" style={{ marginRight: '-14px' }}>
                    <NoAuthAlertComponent />
                </div>)
            }

            <div className='flex justify-start items-start'>
                <span className='mr-2'>
                    <img src="/assets/img/icons/massage-icon.svg" alt="Masaje" />
                </span>
                <div className='flex flex-col'>
                    <span className='title mb-2'>Masaje Romántico by Israel Galindo “El Muñeco sexual”</span>
                    <span style={{ color: '#4B5563' }}> <strong>Lugar:</strong> Spa del Hotel</span>
                </div>
            </div>

            <br />
            <hr />
            <div className='mt-4' style={{ fontSize: '16px' }}>
                Información
            </div>
            <p className='mt-2'>
                Horario: Mon-Sun: <strong>08:00 AM - 07:00 PM</strong>
            </p>
            <div className='mt-4'>
                <div>
                    <span> {checkIcon} Clases de gimnasia disponibles</span>

                </div>
                <div className='mt-1'>
                    <span>{checkIcon} Envoltura corporal</span>

                </div>
                <div className='mt-1'>
                    <span>{checkIcon} Masaje en pareja</span>

                </div>
                <div className='mt-1'>
                    <span>{checkIcon} Masajes</span>

                </div>
                <div className='mt-1'>
                    <span>{checkIcon} Tratamientos faciales</span>

                </div>
            </div>
            {
                user && (
                    <>
                        <div className='mt-4 title'>Día y hora del Servicio</div>
                        <br />
                        <hr />
                        <br />
                        <ExperienceOrderCard />
                    </>
                )
            }
        </div>

    </>;
};

const msgWarnStyle: CSS.Properties = {
    color: '#012349',
    height: '60px',
    fontSize: '14px',
    backgroundColor: '#FFE36F',
    width: '100vw',
    paddingRight: '50px',
    paddingLeft: '50px',
    marginLeft: '-14px',
    marginTop: '-14px',
    marginBottom: '14px',
    fontWeight: '600',
    lineHeight: '14px',
    textAlign: 'center'
}